import { render } from "./ApiIntegrationsWrapper.vue?vue&type=template&id=67a173b8&scoped=true"
import script from "./ApiIntegrationsWrapper.vue?vue&type=script&lang=js"
export * from "./ApiIntegrationsWrapper.vue?vue&type=script&lang=js"

import "./ApiIntegrationsWrapper.vue?vue&type=style&index=0&id=67a173b8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a173b8"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QIcon,QBtn});
